
import axios from 'axios';
const API_URL = process.env.VUE_APP_RUTA_API;

class AuthService{
    login(){
    return axios
    .get(API_URL + '/obtenerMenu/4')
        .then(response => {
          localStorage.setItem('menu', JSON.stringify(response.data))
          return response.data
        })
   
    }
    logout(){
        localStorage.removeItem('menu');
    }
}


export default new AuthService();

